import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const sections = [
  { id: "o-nama", label: "O nama" },
  { id: "certifikati", label: "Certifikati" },
  { id: "usluge", label: "Usluge" },
  { id: "cjenik", label: "Cjenik" },
  { id: "galerija", label: "Galerija" },
  { id: "metal-detox", label: "L'Oréal" },
  { id: "lokacija", label: "Kontakt" },
];

export const Navbar = ({ onBookClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled ? "bg-emerald-darker/90 backdrop-blur-md py-4 border-b border-[#C9A86A]/15" : "bg-transparent py-7"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="nav-logo"
          className="font-serif text-gold text-xl md:text-2xl tracking-wide hover:opacity-80 transition"
        >
          La Maison <span className="font-sans tracking-luxury text-[0.6rem] ml-1 align-middle">BY FP</span>
        </button>

        <div className="hidden md:flex items-center gap-10">
          {sections.map((s) => (
            <button
              key={s.id}
              onClick={() => go(s.id)}
              data-testid={`nav-${s.id}`}
              className="font-sans text-xs tracking-luxury uppercase text-[#F5EFE3] hover:text-gold transition-colors duration-300"
            >
              {s.label}
            </button>
          ))}
          <button
            onClick={onBookClick}
            data-testid="nav-book-btn"
            className="btn-luxury"
          >
            Rezerviraj
          </button>
        </div>

        <button
          className="md:hidden text-gold"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="nav-mobile-toggle"
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            {open ? (
              <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
            ) : (
              <>
                <path d="M4 7h16" strokeLinecap="round" />
                <path d="M4 17h16" strokeLinecap="round" />
              </>
            )}
          </svg>
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-emerald-darker/95 border-t border-[#C9A86A]/15 px-6 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {sections.map((s) => (
            <button
              key={s.id}
              onClick={() => go(s.id)}
              className="text-left font-sans text-sm tracking-wide-2 uppercase text-[#F5EFE3] hover:text-gold"
            >
              {s.label}
            </button>
          ))}
          <button onClick={() => { setOpen(false); onBookClick?.(); }} className="btn-luxury self-start mt-2">
            Rezerviraj
          </button>
        </div>
      )}
    </nav>
  );
};
